import { Link, useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import { FiCheck, FiShoppingBag, FiHome, FiList, FiCreditCard } from "react-icons/fi";
import Nav from "../../components/home/Nav";
import { toman } from "../../utils/persian";
import { useRequestPaymentMutation, useRequestSnappPaymentMutation, usePaymentSettingsQuery } from "../../store/services/paymentService";
import { orderDetailUrl } from "../../utils/orderUrl";
import snappPayLogo from "../../assets/payment/snapp-pay-logo.svg";

const OrderSuccess = () => {
  const { id } = useParams();
  const location = useLocation();
  const order = location.state?.order;
  const [requestPayment, paymentResponse] = useRequestPaymentMutation();
  const [requestSnappPayment, snappPaymentResponse] = useRequestSnappPaymentMutation();
  const paymentSettingsResponse = usePaymentSettingsQuery();
  const snappPayEnabled = Boolean(paymentSettingsResponse.data?.snapp_pay?.enabled);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(order?.payment_method === "snapp_pay" ? "snapp_pay" : "online_gateway");
  const loading = paymentResponse.isLoading || snappPaymentResponse.isLoading;

  const startPayment = async () => {
    try {
      const res = selectedPaymentMethod === "snapp_pay"
        ? await requestSnappPayment(id).unwrap()
        : await requestPayment(id).unwrap();

      const paymentUrl = res.payment_url || res.paymentPageUrl || res.paymentUrl || res.url;

      if (paymentUrl) {
        window.location.href = paymentUrl;
      }
    } catch (err) {
      alert(err?.data?.message || "خطا در اتصال پرداخت");
    }
  };

  return (
    <>
      <Nav />

      <main className="order-success-page">
        <div className="site-container">
          <div className="order-success-card">
            <div className="order-success-icon">
              <FiCheck size={42} />
            </div>

            <span className="order-success-kicker">سفارش ثبت شد</span>

            <h1>سفارش ثبت شد</h1>

            <p>سفارش آماده پرداخت است.</p>

            <div className="order-success-info">
              <div>
                <span>شماره سفارش</span>
                <strong>{order?.order_number || `#${id}`}</strong>
              </div>

              <div>
                <span>مبلغ سفارش</span>
                <strong>{order?.total !== undefined ? toman(order.total) : "-"}</strong>
              </div>

              <div>
                <span>پرداخت</span>
                <strong>{order?.payment_status === "paid" ? "پرداخت شده" : "در انتظار پرداخت"}</strong>
              </div>
            </div>

            {order?.payment_status !== "paid" && (
              <>
                <div className="payment-retry-methods order-payment-methods">
                  <button
                    type="button"
                    className={selectedPaymentMethod === "online_gateway" ? "active" : ""}
                    onClick={() => setSelectedPaymentMethod("online_gateway")}
                  >
                    <FiCreditCard size={18} />
                    <span>پرداخت آنلاین</span>
                  </button>

                  {snappPayEnabled && (
                    <button
                      type="button"
                      className={selectedPaymentMethod === "snapp_pay" ? "active snapp" : "snapp"}
                      onClick={() => setSelectedPaymentMethod("snapp_pay")}
                    >
                      <img src={snappPayLogo} alt="SnappPay" />
                      <span>خرید اعتباری با اسنپ‌پی</span>
                    </button>
                  )}
                </div>

                <button
                  type="button"
                  className="order-pay-button"
                  onClick={startPayment}
                  disabled={loading}
                >
                  <FiCreditCard size={18} />
                  {loading ? "در حال اتصال..." : selectedPaymentMethod === "snapp_pay" ? "ادامه با اسنپ‌پی" : "پرداخت آنلاین"}
                </button>
              </>
            )}

            <div className="order-success-actions">
              <Link to={orderDetailUrl(id)}>
                <FiShoppingBag size={18} />
                جزئیات
              </Link>

              <Link to="/orders">
                <FiList size={18} />
                سفارش‌ها
              </Link>

              <Link to="/">
                <FiHome size={18} />
                فروشگاه
              </Link>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default OrderSuccess;
